@if (maler().length > 0) {
  <span class="overskrift">{{ 'Maler'|translate }}</span>

  <table mat-table matSort [dataSource]="malerDataSource">

    <ng-container matColumnDef="logo">
      <th mat-header-cell *matHeaderCellDef class="logo"></th>
      <td mat-cell *matCellDef="let mal" style="background: linear-gradient(to right, {{mal.farge}} 10px, transparent 10px);"  class="logo">
        <gruppe-logo [gruppe]="mal" [stil]="'stor'"/>
      </td>
    </ng-container>
    <ng-container matColumnDef="organisasjonsnavn">
      <th *matHeaderCellDef mat-header-cell mat-sort-header> {{ 'Organisasjon'|translate }}</th>
      <td mat-cell *matCellDef="let mal"> {{ mal.organisasjonsnavn }}</td>
    </ng-container>
    <ng-container matColumnDef="tittel">
      <th mat-header-cell mat-sort-header *matHeaderCellDef > {{ 'Gruppe'|translate }}</th>
      <td mat-cell *matCellDef="let mal"> {{ mal.tittel }}</td>
    </ng-container>
    <ng-container matColumnDef="mal">
      <th mat-header-cell mat-sort-header *matHeaderCellDef > {{'Gruppemal'|translate}}</th>
      <td mat-cell *matCellDef="let mal">{{mal.gruppemal.navn}}</td>
    </ng-container>
    <ng-container matColumnDef="beskrivelse">
      <th mat-header-cell mat-sort-header *matHeaderCellDef > {{ 'Beskrivelse'|translate }}</th>
      <td mat-cell *matCellDef="let mal">{{mal.gruppemal.beskrivelse}}</td>
    </ng-container>

    <ng-container matColumnDef="innlogging">
      <th mat-header-cell  mat-sort-header *matHeaderCellDef> {{ 'Sikkerhetsnivå innlogging'|translate }}</th>
      <td mat-cell *matCellDef="let mal" [matTooltip]="autentiseringsmetoder(mal).join(', ')">
        {{ lavesteAutentiseringsmetodeTekst(mal)}}
      </td>
    </ng-container>
    <ng-container matColumnDef="vis">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let mal" class="handlinger">
        <button mat-button type="button" (click)="gaaTilGruppe(mal.id)" data-testid="vis-detaljer">
          <mat-icon fontSet="ion-ios-arrow-thin-right" class="mat-icon--ionic-ikon"/>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['logo','organisasjonsnavn', 'tittel','mal','beskrivelse','innlogging','vis']"></tr>
    <tr mat-row class="rad" *matRowDef="let mal; columns: ['logo','organisasjonsnavn', 'tittel','mal','beskrivelse','innlogging','vis'];" (click)="gaaTilGruppe(mal.id)"></tr>

  </table>
}
